"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
TYCOON.pageScript = TYCOON.pageScript || {
  init: {}
};
TYCOON.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    TYCOON.common.initFilterMenu();
    TYCOON.common.initAccordion();
    TYCOON.common.initSortSelectWidth();
    new CollectionPageInitializer();
    initChildCollectionRadio();
    initCascadingFilterRemoval();
  }

  /*
  *
  *  CollectionPageInitializer クラス
  *
  */
  var CollectionPageInitializer = /*#__PURE__*/function () {
    // コンストラクタ  =================================================================
    function CollectionPageInitializer() {
      _classCallCheck(this, CollectionPageInitializer);
      // DOM要素の参照
      this.$productGrid = $('#ProductGridContainer');
      this.$collectionContainer = $('.collection');
      this.$body = $('body');
      this.$filterLoading = $('#FilterLoading');

      // 性別フィルターのパラメータ名
      this.genderFilterParam = 'filter.p.m.custom.product_gender';

      // タイムアウト設定
      this.displayDelay = 100;
      this.fallbackTimeout = 2000;

      // フィルタリング状態フラグ
      this.isFiltering = false;

      // 初期化処理を実行
      this.handleInitialLoad();
      this.setupFilterLoadingState();
    }

    // private methods  ==========================================================

    /*
    *
    *  初期ロード時の制御
    *
    */
    return _createClass(CollectionPageInitializer, [{
      key: "handleInitialLoad",
      value: function handleInitialLoad() {
        if (this.$productGrid.length === 0 && this.$collectionContainer.length === 0) return;
        var storedGender = TYCOON.common.getStoredGender();
        if (!storedGender) {
          // 性別が保存されていない場合は即座に表示
          this.showProductGrid();
        } else {
          // 性別が保存されている場合はフィルター適用後に表示
          this.applyGenderFilterWithDisplay();
        }
      }

      /*
      *
      *  商品一覧を表示
      *
      */
    }, {
      key: "showProductGrid",
      value: function showProductGrid() {
        // CSSクラスを削除して表示
        this.$body.removeClass('collection-page-loading');
      }

      /*
      *
      *  性別フィルターを適用（表示制御付き）
      *
      */
    }, {
      key: "applyGenderFilterWithDisplay",
      value: function applyGenderFilterWithDisplay() {
        var _this = this;
        var storedGender = TYCOON.common.getStoredGender();
        if (!storedGender) {
          this.showProductGrid();
          return;
        }

        // 現在のURLパラメータを取得
        var urlParams = new URLSearchParams(window.location.search);

        // 既に性別フィルターが適用されているかチェック
        if (urlParams.has(this.genderFilterParam)) {
          this.showProductGrid();
          return;
        }

        // 既存のフィルターパラメータを保持しつつ、性別フィルターを追加
        urlParams.set(this.genderFilterParam, storedGender);

        // facets.jsの機能を使用してページを更新
        if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
          var isRendered = false;

          // ProductGridContainerのDOM更新を監視
          var observer = new MutationObserver(function (mutations) {
            if (isRendered) return;

            // innerHTML更新を検知（childListの変更）
            for (var i = 0; i < mutations.length; i++) {
              if (mutations[i].type === 'childList') {
                isRendered = true;
                observer.disconnect();

                // 少し待ってから表示
                setTimeout(function () {
                  _this.showProductGrid();
                }, _this.displayDelay);
                return;
              }
            }
          });

          // ProductGridContainerを監視
          if (this.$productGrid[0]) {
            observer.observe(this.$productGrid[0], {
              childList: true,
              subtree: false
            });
          }

          // facets.jsのrenderPageメソッドを使用
          // 履歴を書き換えて、パラメータなしのURLを残さない
          var newUrl = window.location.pathname + '?' + urlParams.toString();
          history.replaceState({
            searchParams: urlParams.toString()
          }, '', newUrl);

          // 第3引数をfalseにして、renderPage内でのURL更新を防ぐ
          FacetFiltersForm.renderPage(urlParams.toString(), null, false);

          // フォールバック: 2秒後に強制表示
          setTimeout(function () {
            if (!isRendered) {
              isRendered = true;
              observer.disconnect();
              _this.showProductGrid();
            }
          }, this.fallbackTimeout);
        } else {
          // フォールバック: ページをリロード
          var newUrl = window.location.pathname + '?' + urlParams.toString();
          window.location.href = newUrl;
        }
      }

      /*
      *
      *  性別フィルターを適用（従来の関数）
      *
      */
    }, {
      key: "applyGenderFilter",
      value: function applyGenderFilter() {
        var storedGender = TYCOON.common.getStoredGender();
        if (!storedGender) {
          return;
        }

        // 現在のURLパラメータを取得
        var urlParams = new URLSearchParams(window.location.search);

        // 既に性別フィルターが適用されているかチェック
        if (urlParams.has(this.genderFilterParam)) {
          return;
        }

        // 既存のフィルターパラメータを保持しつつ、性別フィルターを追加
        urlParams.set(this.genderFilterParam, storedGender);

        // facets.jsの機能を使用してページを更新
        if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
          // facets.jsのrenderPageメソッドを使用
          FacetFiltersForm.renderPage(urlParams.toString(), null, true);
        } else {
          // フォールバック: ページをリロード
          var newUrl = window.location.pathname + '?' + urlParams.toString();
          window.location.href = newUrl;
        }
      }

      /*
      *
      *  性別フィルターをクリアする関数
      *
      */
    }, {
      key: "clearGenderFilter",
      value: function clearGenderFilter() {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has(this.genderFilterParam)) {
          urlParams.delete(this.genderFilterParam);
          var newUrl = window.location.pathname + '?' + urlParams.toString();
          if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
            FacetFiltersForm.renderPage(urlParams.toString(), null, true);
          } else {
            window.location.href = newUrl;
          }
        }
      }

      /*
      *
      *  フィルター送信時のローディング状態を制御
      *
      */
    }, {
      key: "setupFilterLoadingState",
      value: function setupFilterLoadingState() {
        var self = this;

        // フェードインを実行する共通関数
        var fadeInProductGrid = function fadeInProductGrid() {
          if (!self.isFiltering) return;
          clearTimeout(self.fallbackTimeout);

          // ローディング非表示
          if (self.$filterLoading.length) {
            self.$filterLoading.removeClass('is-visible');
            setTimeout(function () {
              self.$filterLoading.hide();
            }, 200);
          }
          gsap.to(self.$productGrid, {
            opacity: 1,
            duration: 0.05,
            ease: 'power2.in'
          });
          self.isFiltering = false;
        };

        // フェードアウトアニメーションを実行する共通関数
        var fadeOutProductGrid = function fadeOutProductGrid() {
          self.isFiltering = true;

          // ローディング表示
          if (self.$filterLoading.length) {
            self.$filterLoading.show().addClass('is-visible');
          }
          gsap.to(self.$productGrid, {
            opacity: 0,
            duration: 0.05,
            ease: 'power2.out'
          });

          // フォールバック: 2秒後に強制的にフェードイン
          clearTimeout(self.fallbackTimeout);
          self.fallbackTimeout = setTimeout(function () {
            if (self.isFiltering) {
              fadeInProductGrid();
            }
          }, 2000);
        };

        // フィルター操作時にフェードアウト
        $(document).on('submit', 'facet-filters-form form', fadeOutProductGrid).on('change', 'facet-filters-form input[type="checkbox"]', fadeOutProductGrid).on('click', '.c-tags_radio', fadeOutProductGrid);

        // facets.jsのAJAX完了を監視
        var originalFetch = window.fetch;
        window.fetch = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var url = args[0];
          return originalFetch.apply(this, args).then(function (response) {
            // facets関連のリクエストの場合のみ処理
            if (url && typeof url === 'string' && (url.includes('sections=') || url.includes('section_id=')) && self.isFiltering) {
              // レスポンス取得後、DOM更新を待つため少し遅延
              response.clone().text().then(function () {
                setTimeout(function () {
                  fadeInProductGrid();
                }, 50);
              });
            }
            return response;
          });
        };
      }
    }]);
  }();
  /*
   * カテゴリーフィルターの連動解除処理
   * 親カテを外すと、子カテ・孫カテも連動して外れる（AJAX対応）
   */
  function initCascadingFilterRemoval() {
    // カテゴリー系フィルターかどうかを判定
    var isCategoryFilter = function isCategoryFilter(paramName) {
      return paramName === 'filter.p.m.custom.product_p_collection' || paramName === 'filter.p.m.custom.product_c_collection' || paramName.includes('product_g_collection');
    };

    // 子孫チェックボックスを再帰的に収集
    var _collectDescendants = function collectDescendants(parentValue) {
      var descendants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var $children = $("facet-filters-form input[type=\"checkbox\"][data-parent-collection=\"".concat(parentValue, "\"]"));
      $children.each(function () {
        var $child = $(this);
        if ($child.is(':checked')) {
          descendants.push($child);
          _collectDescendants($child.val(), descendants);
        }
      });
      return descendants;
    };

    // フォームからURLパラメータを構築
    var buildFormParams = function buildFormParams($form) {
      var formData = new FormData($form[0]);
      var params = new URLSearchParams();
      var _iterator = _createForOfIteratorHelper(formData.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          if (value) params.append(key, value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return params;
    };

    // チェックボックスのchangeイベント監視
    $(document).on('change', 'facet-filters-form input[type="checkbox"]', function (e) {
      var $checkbox = $(this);

      // チェックが外された、かつカテゴリーフィルターの場合のみ処理
      if ($checkbox.is(':checked') || !isCategoryFilter($checkbox.attr('name'))) return;
      var descendants = _collectDescendants($checkbox.val());

      // 子孫が存在する場合、手動でAJAX更新
      if (descendants.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // 子孫と親のチェックを外す
        descendants.forEach(function ($child) {
          return $child.prop('checked', false);
        });
        $checkbox.prop('checked', false);

        // AJAX更新
        var params = buildFormParams($checkbox.closest('form'));
        if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
          FacetFiltersForm.renderPage(params.toString());
        }
      }
    });
  }

  /*
  *
  *  子コレクションタグのradioボタンクリック処理（AJAX版）
  *  - 選択中のradioボタンをクリック: 一個上の階層に遷移（パラメータ削除）
  *  - 別のradioボタンをクリック: フィルターを適用（パラメータ追加）
  *  - facets.jsのAJAXを利用
  *
  */
  function initChildCollectionRadio() {
    $(document).on('click', '.c-tags_radio', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $label = $(this);
      var $radio = $label.find('.js-childCollectionRadio');
      if ($radio.length === 0) return;
      var filterParam = $radio.data('param');
      var filterValue = $radio.val();
      var isChecked = $radio.is(':checked');
      if (isChecked) {
        // 選択中 → facetsのチェックボックスを外す
        var $targetFacetCheckbox = $("facet-filters-form input[name=\"".concat(filterParam, "\"][value=\"").concat(filterValue, "\"]"));
        if ($targetFacetCheckbox.length) {
          $targetFacetCheckbox.prop('checked', false);

          // ネイティブのInputEventを作成して発火
          var inputEvent = new Event('input', {
            bubbles: true,
            cancelable: true
          });
          $targetFacetCheckbox[0].dispatchEvent(inputEvent);
        }
      } else {
        // 未選択 → facetsのチェックボックスをオン
        // 同じparamのチェックボックスを全て解除
        var $allFacetCheckboxes = $("facet-filters-form input[name=\"".concat(filterParam, "\"]"));
        $allFacetCheckboxes.prop('checked', false);

        // 選択されたもののみチェック
        var _$targetFacetCheckbox = $("facet-filters-form input[name=\"".concat(filterParam, "\"][value=\"").concat(filterValue, "\"]"));
        if (_$targetFacetCheckbox.length) {
          _$targetFacetCheckbox.prop('checked', true);

          // ネイティブのInputEventを作成して発火
          var _inputEvent = new Event('input', {
            bubbles: true,
            cancelable: true
          });
          _$targetFacetCheckbox[0].dispatchEvent(_inputEvent);
        }
      }
    });
  }
  return {
    init: init
  };
}();
TYCOON.common.init(TYCOON.pageScript.init);